<!-- 公告列表 -->
<template>
  <div v-loading="loading">
    <div class="boxlistTit">
      <el-select class="fl" v-model="param.courseId" placeholder="授课班级" style="width:130px;">
        <el-option label="全部" :value="0"></el-option>
        <el-option v-for="item in teachingClass" :label="item.name" :key="item.id" :value="item.id"></el-option>
      </el-select>
      <el-input v-model="param.word" placeholder="公告标题" style="width:300px;margin:0 10px"></el-input>
      <el-button type="primary" @click="ngOnInit">查询</el-button>
      <router-link
        :to="`/teacherManage`"
        style="margin-left:10px"
        class="fr"
      >
        <el-button type="primary">返回</el-button>
      </router-link>
      <router-link
        :to="`/alliance/teacher/${$route.query.schoolId}/announcement/edit?schoolId=${$route.query.schoolId}&teacherId=${$route.query.teacherId}`"
      >
        <el-button type="primary" class="fr">新建</el-button>
      </router-link>
    </div>

    <el-table :data="noticeData">
      <el-table-column prop="title" label="公告标题"></el-table-column>
      <el-table-column prop="createdDate" label="发布时间"></el-table-column>
      <el-table-column label="授课班级">
        <template slot-scope="scope">
          <span v-for="(item,idx) in scope.row.courseNames" :key="idx">{{item}}、</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <div>
            <el-button type="primary" size="small" @click="editClass(scope)">修改可见班级</el-button>
            <el-button type="danger" size="small" @click="delCourse(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="foot-pager"
      :page-size="10"
      :pager-count="11"
      layout="prev, pager, next"
      :total="total"
      :current-page.sync="param.startIndex"
      @current-change="ngOnInit"
    ></el-pagination>

    <el-dialog
      v-loading="loading"
      title="提示"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      @opened="openCallBack"
      width="1000px"
    >
      <announce :getCourseWare="getCourseWare" :getCourse="getCourse" ref="openCallBack"></announce>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="compile">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import announce from "../common/announce";
export default {
  components: { announce },
  data() {
    return {
      getCourse: {
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId,
      },
      getCourseWare: {
        announceId: 0,
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId,
      },
      dialogVisible: false,
      total: 0,
      loading: false,
      teachingClass: [],
      noticeData: [],
      paramSummary: {
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId,
      },
      param: {
        courseId: 0,
        word: "",
        showItem: 10,
        schoolId: this.$route.query.schoolId,
        pageIndex: 1,
        teacherId: this.$route.query.teacherId,
      },
    };
  },
  created() {
    this.getCourseSummaryList();
    this.ngOnInit();
  },
  methods: {
    // 删除公告
    delCourse(item) {
      this.$confirm("您确认删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const params = {
          schoolId: this.$route.query.schoolId,
          announceId: item.announceId,
        };
        this.$api.allianceSchool.delAnnounce(params).then((res) => {
          if (res.errCode == 0) {
            this.param.startIndex = 1;
            this.ngOnInit();
          } else {
            this.$message.error(res.errMsg);
          }
        });
      });
    },
    // 确认修改可见
    compile() {
      const param = {
        courseIds: this.$refs.openCallBack.checkedCities,
        announceId: this.$refs.openCallBack.getCourseWare.announceId,
        schoolId: this.$refs.openCallBack.getCourseWare.schoolId,
      };
      this.loading = true;
      this.$api.allianceSchool
        .updateAnnounceVisible(param)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.dialogVisible = false;
            this.ngOnInit();
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    // 编辑
    editClass(item) {
      this.getCourseWare.announceId = item.row.announceId;
      this.dialogVisible = true;
    },
    // 模态框回调
    openCallBack() {
      this.$refs.openCallBack.ngOnInit();
    },
    // 获取可见授课班级
    getCourseSummaryList() {
      this.loading = true;
      this.$api.allianceSchool
        .getCourseSummaryList(this.paramSummary)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.teachingClass = res.data;
          } else {
            this.$message.error(res.errMsg);
          }
        });
    },
    // 公告列表
    ngOnInit() {
      this.loading = true;
      this.$api.allianceSchool
        .queryAnnounceList(this.param)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.noticeData = res.data.items;
            this.total = res.data.totalItems;
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang='less' scoped>
.foot-pager {
  text-align: center;
}
</style>